import React from 'react';
import styles from './Header.module.css';

function Header(props) {
  return (
    <div className={styles.header}>
      <table style={{ width: '100%' }}>
        <tbody>
          <tr>
            <td className={styles.title}>{'Legenda'}</td>

            <td
              style={{ width: '30px', cursor: 'pointer' }}
              className={`no-print${props.hide.print ? ' fs-hidden' : ''}`}
            >
              <img
                alt="Print"
                onClick={() => {
                  window.print();
                }}
                title="Printaj ovu stranicu"
                className="headerButton"
                src={images['print-icon.svg']}
              />
            </td>
            <td
              style={{ width: '60px' }}
              className={`no-print${props.hide.newWindow ? ' fs-hidden' : ''}`}
            >
              <img
                alt="Open In New Window"
                onClick={() => {
                  window.open(window.location.href, '_blank');
                }}
                title="Open this page in a new window"
                className="headerButton"
                src={images['new-window-icon.png']}
              />
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
}

export default Header;

// IMPORT ALL IMAGES
const images = importAllImages(
  require.context('./images', false, /\.(png|jpe?g|svg|gif)$/)
);
function importAllImages(r) {
  let images = {};
  // eslint-disable-next-line
  r.keys().map((item, index) => {
    images[item.replace('./', '')] = r(item);
  });
  return images;
}
